import { Paper } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { featureCollection } from '@turf/turf';

import FieldsInBounds, {
  INTERACTIVE_LAYER_IDS,
  useFieldsInBoundsClick,
} from '../../components/fields-in-bounds/fields-in-bounds';

import { useQueriesWithGlobal } from '@data-access';
import { fieldsQueries } from '@fields/data-access';
import { CopyWktButton, PfMap, PlotsLayer } from '@map';

export function FieldMap() {
  const { fieldId } = useParams({ from: '/_app/fields_/$fieldId' });

  const handleMapClick = useFieldsInBoundsClick();

  const queries = useQueriesWithGlobal(fieldsQueries);
  const { data } = useSuspenseQuery(queries.detail(Number(fieldId)));

  return (
    <Paper h="100%" p={0}>
      <PfMap
        interactiveLayerIds={INTERACTIVE_LAYER_IDS}
        onClick={handleMapClick}
        zoomToGeojson={data}
      >
        <FieldsInBounds fieldId={fieldId} toggleable />
        <PlotsLayer
          data={featureCollection([data])}
          id={`field-layer-${fieldId}`}
          key={fieldId}
          sourceId={`field-data-${fieldId}`}
        />
        <CopyWktButton field={data} />
      </PfMap>
    </Paper>
  );
}

export default FieldMap;
